<template lang="pug">
    span(class="_tag", :class="{ ['bg-'+tone]: tone, ['_e'+appearance]: appearance }")
        span(class="_tagi")
            slot &zwnj;
        ib-button(
            v-if="deletable",
            type="button",
            tone="gray",
            class="link",
            tabindex="-1",
            :disabled="disabled",
            @mousedown.stop="",
            @click="onDelete")
            include ../../icon/basic/close.svg
</template>

<script>
    /**
     * A styled tag (known as a Chip in Material Design) with an optional delete button.
     */
    export default {
        name: 'ib-tag',

        props: {
            /**
             * Semantic color class.
             */
            tone: String,
            /**
             * Appearance modifier:
             * - `arrow`: Five sided shape similar to a price tag.
             * - `rectangle`: Four sided rectangle.
             * - `large`: Similar to default appearance, but larger.
             */
            appearance: String,
            /**
             * Toggles whether the tag should be rendered with an 'x'
             */
            deletable: Boolean,
            /**
             * If deletable, sets the disabled property on the delete button.
             */
            disabled: Boolean
        },

        methods: {
            /**
            * 'delete' event
            * @event
            * @type{null}
            */
            onDelete() {
                this.$emit('delete');
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";
    @bg-default: mix(@bg, @fg-max, 95%);

    ._tag {
        position: relative;
        display: inline-flex;
        align-items: center;
        padding: 0 10px;
        .font-size(@fs6);
        font-weight: 400;
        line-height: 1.25;
        max-width: 100%;
        white-space: nowrap;
        border: 1px solid fade(@fg-max, 5%);
        border-radius: 99px;
        color: @fg;
        background-color: @bg-default;

        &._elarge {
            line-height: 2;
            padding: 0 16px;
        }
        &._earrow {
            margin-left: .7071em;
            border: none;
            border-radius: 0;
            padding: 1px 10px;
            -webkit-padding-start: 6px;
            padding-inline-start: 6px;
            &::before {
                content: '';
                position: absolute;
                display: inline-block;
                top: 0;
                width: calc(~'.8839em + 1px');
                height: 70.7107%;  /** 1 / sqrt(2) */
                background-color: inherit;
                z-index: -1;
            }
        }
        &._erectangle {
            border-radius: 0;
        }

        > ._btn {
            margin: 0 -6px 0 6px;
            > svg {
                width: 12px;
                height: 12px;
                vertical-align: -1.5px;
            }
        }
    }

    ._tagi {
        flex: 1 1 auto;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    [dir=ltr] ._tag,
    [dir=rtl] [dir=ltr] ._tag {
        &._earrow {
            &::before {
                left: 0;
                transform-origin: 0 0;
                transform: rotate(45deg);
            }
        }
    }

    [dir=rtl] ._tag,
    [dir=ltr] [dir=rtl] ._tag {
        &._earrow {
            &::before {
                right: 0;
                transform-origin: 100% 0;
                transform: rotate(-45deg);
            }
        }
    }

</style>

<docs>
    Basic Example:
    ```jsx
    <ib-context>
        <ib-tag deletable>Hello World</ib-tag>
    </ib-context>
    ```
</docs>
